import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type InvoiceFileParams, type InvoiceFileResponse } from './types';
import {
  zodInvoiceFileEndpointSchema,
  zodInvoiceFileSearchParamsSchema,
} from './validations';

/**
 * Fetches an invoice file by invoice ID and requested file type.
 *
 * @param params - Parameters for selecting invoice and file type.
 * @param options - The options for the request (includes abort signal).
 * @returns The invoice file as a Blob.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/get_invoice_file
 */
export const fetchInvoiceFile = async (
  params: InvoiceFileParams,
  options?: KyRequestOptions,
): Promise<InvoiceFileResponse> => {
  const response = await vestigasApi
    .get(ENDPOINT.INVOICE.GET_FILE_BY_TYPE(params.invoiceId), {
      searchParams: {
        fileType: params.fileType,
      },
      validate: {
        pathSegments: zodInvoiceFileEndpointSchema,
        searchParams: zodInvoiceFileSearchParamsSchema,
      },
      ...options,
    })
    .blob();

  return response;
};
